import React from 'react'
import { Breadcrumb, FindAgent, LegalDisclaimerContent, MainHeading, NoticeLinks } from '../../components';
import { Col, Container, Row } from 'react-bootstrap';

const LegalDisclaimer = () => {
    const crumbsdata = [
        { label: 'Sentry Insurance home', link: '/' },
        { label: 'Legal disclaimer', link: '/footer/legal-disclaimer' }
    ]
    return (
        <div className='legal-disclaimer-wrapper'>
            <Container>
            <Breadcrumb crumbs={crumbsdata} />
                <MainHeading title="Legal information" showshare={false} />
                <div className='content-pages-wrapper'>
                    <Row>
                        <Col md={8} sm={12}  className='order-md-1 order-2'>
                        <LegalDisclaimerContent/>
                        </Col>
                        <Col md={4} sm={12}  className='order-md-2 order-1'>
                            <NoticeLinks />
                        </Col>
                    </Row>
                </div>
                <FindAgent />
            </Container>
        </div>
    )
}

export default LegalDisclaimer;